import React from 'react'
import { Link } from 'react-router-dom'
import { NavBar } from './NavBar'

interface PageLayoutProps {
  children: React.ReactNode
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl'
}

const maxWidthStyles = {
  sm: 'max-w-2xl',
  md: 'max-w-4xl',
  lg: 'max-w-6xl',
  xl: 'max-w-7xl',
}

export const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  maxWidth = 'xl',
}) => {
  return (
    <div className="min-h-screen bg-background">
      <NavBar />
      <div className={`${maxWidthStyles[maxWidth]} mx-auto py-6 px-4 sm:px-6 lg:px-8`}>
        {children}
      </div>
    </div>
  )
}

interface PageHeaderProps {
  title: string
  subtitle?: string
  backTo?: string
  backLabel?: string
  actions?: React.ReactNode
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  backTo,
  backLabel = 'Back',
  actions,
}) => {
  return (
    <div className="mb-6">
      {backTo && (
        <Link to={backTo} className="inline-flex items-center text-sm text-foreground-muted hover:text-foreground mb-3">
          <svg className="mr-1.5 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          {backLabel}
        </Link>
      )}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-foreground">{title}</h1>
          {subtitle && <p className="mt-1 text-foreground-muted">{subtitle}</p>}
        </div>
        {actions && <div className="flex gap-3">{actions}</div>}
      </div>
    </div>
  )
}
